import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import classnames from 'classnames';
import { client } from 'cccisd-apollo';
import { DeploymentPlayer } from 'cccisd-laravel-assignment';
import { Html } from 'cccisd-wysiwyg';
import Loader from 'cccisd-loader';
import moment from 'moment';
import Modal from 'cccisd-modal';
import style from './style.css';
import _get from 'lodash/get';
import Play from 'cccisd-icons/play4';
import IconCheck from 'cccisd-icons/checkmark-circle';
import assignmentPlansQuery from './assignmentPlans.graphql';
const tabs = [
    { handle: 'provider', name: 'Provider-Led Strategies', tab: 'tab' },
    { handle: 'student', name: 'Student Self-Paced Strategies', tab: 'tab1' },
];

const Fortress = window.cccisd.fortress;

const TreatmentStrategies = () => {
    const params = useParams();
    const match = tabs.find(item => item.handle === params?.tab);

    const [tab, setTab] = useState(match ? match.handle : 'provider');
    const [loading, setLoading] = useState(true);
    const [planData, setPlanData] = useState(match ? match.handle : 'provider');
    const [providerCollection, setProviderCollection] = useState([]);
    const [studentCollection, setStudentCollection] = useState([]);
    const [flowProgress, setFlowProgress] = useState([]);
    // const [flowData, setFlowData] = useState([]);
    // const [planResources, setPlanResources] = useState([]);

    useEffect(() => {
        getCollections();
    }, []);

    const getCollections = async () => {
        setLoading(true);
        const response = await client.query({
            query: assignmentPlansQuery,
            fetchPolicy: 'network-only',
            variables: {
                pawnId: Fortress.user.acting.id,
            },
        });

        const planData = _get(response, 'data.roles.anyRole.createdAssignmentPlan');
        const progressData = _get(response, 'data.flows.flowProgressList');
        // const flowList = _get(response, 'data.flows.flowList');

        setPlanData(planData);
        setFlowProgress(progressData);
        // setFlowData(flowList);

        // console.log({ planData, progressData, flowList });
        // get the resources for each reporter type
        if (planData.length !== null) {
            const studentResCollection = {
                assignmentPlanId: planData.assignmentPlanId,
                label: planData.label,
                sessionList: planData.sessionList.filter(session => session.label.includes('Student')),
            };

            const providerResCollection = {
                assignmentPlanId: planData.assignmentPlanId,
                label: planData.label,
                sessionList: planData.sessionList.filter(session => session.label.includes('Provider')),
            };

            setProviderCollection(providerResCollection);
            setStudentCollection(studentResCollection);
        }
        setLoading(false);
    };

    const applyTimezoneOffset = date => {
        // Our server uses UTC time so we need to offset the start/end date entered by client
        return moment(date).utc().format('MM-DD-YYYY');
    };

    const renderThumbnail = resource => {
        return (
            <div
                className={style.thumbImage}
                style={{
                    backgroundImage: `url(${resource.large})`,
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                }}
            >
                {/* <img
                    src={resource.thumbnail}
                    alt="resource cover"
                /> */}
            </div>
        );
    };

    const renderSurveyInfo = resource => {
        const metadata = JSON.parse(resource.published_metadata) || {};
        // console.log({ metadata, tab, providerCollection, studentCollection, planData });

        const btnDataArray = {
            'In Progress': {
                class: 'btn-success',
                icon: Play,
                label: 'Continue',
            },
            start: {
                class: 'btn-primary',
                icon: Play,
                label: 'Start',
            },
            Complete: {
                class: 'btn-primary',
                icon: Play,
                label: 'Retake',
            },
        };

        let status = flowProgress.find(flow => {
            return flow.flowHandle === metadata.surveyInfo.surveyHandle;
        });

        const btnData = btnDataArray[status?.status || 'start'];
        const ButtonIcon = btnData.icon;

        const LearnMoreButton = (
            <>
                {metadata.infoResource && (
                    <a
                        className="btn btn-secondary"
                        href={metadata.infoResource.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        role="button"
                    >
                        Learn More
                    </a>
                )}
            </>
        );

        return (
            <div>
                <p className={style.dateAssigned}>Date Assigned: {applyTimezoneOffset(planData.createdDate)}</p>
                <div>
                    <Modal
                        trigger={
                            <button type="button" className={classnames('btn', btnData.class, style.surveyButton)}>
                                <ButtonIcon /> {btnData.label}
                            </button>
                        }
                        // title={metadata.surveyInfo.surveyLabel}
                        size="large"
                        contentStyle={{ width: '1200px' }}
                        headerStyle={{
                            backgroundColor: '#d68f28',
                            color: '#fff',
                        }}
                        bodyStyle={{ backgroundColor: '#edf2f7' }}
                        afterClose={getCollections}
                    >
                        <div>
                            <DeploymentPlayer
                                deploymentHandle={metadata.surveyInfo.assignment.label}
                                pawnId={Fortress.user.acting.id}
                                pawnHash={Fortress.user.acting.random_hash}
                                disableLayout
                                assignmentOptions={[metadata.surveyInfo.surveyHandle]}
                            />
                        </div>
                    </Modal>
                    {LearnMoreButton}
                </div>
                {status?.status === 'Complete' && (
                    <div className={style.surveyStatus}>
                        <span
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#00D067',
                                justifyContent: 'space-between',
                            }}
                        >
                            <span style={{ color: '#283038', marginRight: '45px' }}>
                                Completed on: {applyTimezoneOffset(status.completedDate)}
                            </span>
                            <IconCheck />
                        </span>
                    </div>
                )}
            </div>
        );
    };

    const renderResourceCenter = () => {
        let resourceCollection = [];

        if (tab === 'provider') {
            resourceCollection = providerCollection.sessionList[0]?.settings?.sessionCollection || [];
        }

        if (tab === 'student') {
            resourceCollection = studentCollection.sessionList[0]?.settings?.sessionCollection || [];
        }

        return (
            <div className={style.wrapper}>
                {resourceCollection.map((strategy, i) => {
                    return (
                        <div className={style.item} key={strategy.resource.id}>
                            <div className={style.cardWrapper}>
                                {renderThumbnail(strategy.resource)}
                                <div className={style.content}>
                                    <div>
                                        <h4 className={style.title}>{strategy.resource.published_label}</h4>
                                        <div className={style.description}>
                                            <span style={{ color: '#16498F' }}>
                                                <Html content={strategy.resource.published_description || ''} />
                                            </span>
                                        </div>
                                    </div>
                                    <div>{renderSurveyInfo(strategy.resource)}</div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    if (loading) {
        return <Loader loading />;
    }

    const renderTabs = () => {
        return (
            <>
                {tabs.map((t, i) => (
                    <div
                        key={i}
                        className={style.tab}
                        style={tab === t.handle ? { backgroundColor: '#2C817C' } : { backgroundColor: '#10498A' }}
                        onClick={() => {
                            setTab(t.handle);
                        }}
                    >
                        {t.name}
                    </div>
                ))}
            </>
        );
    };

    return (
        <div>
            <h1>My Treatment Strategies</h1>
            <div className={style.tabWrapper}>{renderTabs()}</div>
            <div>{renderResourceCenter()}</div>
        </div>
    );
};

export default TreatmentStrategies;
